import type { OrderDesign } from "@jasper/client-models";
import type { OrderDesign as GqlOrderDesign } from "../../gql/generated/graphql";
import type { DeepPartial } from "@apollo/client/utilities";

export const formatOrderDesign = (
  orderDesign: DeepPartial<GqlOrderDesign>
): OrderDesign | null => {
  if (!orderDesign.id || !orderDesign.orderId || !orderDesign.status) {
    return null;
  }

  const history =
    orderDesign.orderDesignHistory
      ?.filter(record => record?.id && record?.status && record?.changedAt)
      .map(record => ({
        id: record!.id!,
        status: record!.status!,
        changedAt: record!.changedAt!,
      })) ?? [];

  const comments =
    orderDesign.orderDesignComments
      ?.filter(comment => comment?.id && comment?.comment && comment?.createdAt)
      .map(comment => ({
        id: comment!.id!,
        comment: comment!.comment!,
        translatedComment: comment!.translatedComment ?? undefined,
        attachments:
          (comment!.attachments ?? [])
            .filter(attachment => attachment?.filename && attachment?.url)
            .map(attachment => ({
              filename: attachment!.filename!,
              url: attachment!.url!,
            })) ?? [],
        createdAt: comment!.createdAt!,
        author: {
          firstName: comment!.author?.firstName ?? "Unknown",
          lastName: comment!.author?.lastName ?? "User",
        },
      })) ?? [];

  return {
    id: orderDesign.id,
    orderId: orderDesign.orderId,
    status: orderDesign.status,
    filenames: (orderDesign.filenames as string[]) ?? [],
    createdAt: orderDesign.createdAt,
    updatedAt: orderDesign.updatedAt,
    history,
    comments,
  };
};
